import React from 'react';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

const TypingIndicator = () => (
  <div className="ai-chat-widget-message assistant">
    <AutoAwesomeIcon className="message-icon" fontSize="small" />
    <div className="message-content">
      <span className="typing-indicator">
        <span></span>
        <span></span>
        <span></span>
      </span>
    </div>
  </div>
);

export default TypingIndicator;

